import React, { useState, useEffect } from "react";
import MainButton from "../../../components/button/mainButton";
import "react-calendar/dist/Calendar.css";
import "../../../assets/styles/admin/booking.scss";
import "../../../assets/styles/components/select.scss";
import SelectField from "../../../components/select/selectField";
import EmptyModel from "../../../components/modal/emptyModal";
import { TextBox, Input, Textarea } from "../../../components/textfield";
import CheckboxText from "../../../components/textfield/checkbox";
import interactionPlugin from "@fullcalendar/interaction";
import FullCalendar, {
  EventApi,
  DateSelectArg,
  EventClickArg,
  EventContentArg,
  formatDate,
} from "@fullcalendar/react";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";

const BookingDetail = () => {
  const [value, onChange] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isModel, setModel] = useState<string>("");
  const [options, setOptions] = useState<string>("room");
  const [timeRoomFrom, setTimeRoomFrom] = useState<string>("");
  const [timeRoomTo, setTimeRoomTo] = useState<string>("");
  const [CnRoom, setCRoom] = useState<string>("EK-CNT60090099");
  const [NameRoom, setNameRoom] = useState<string>("นายดนุภัทร สมศรี");
  const [TreatMentRoom, setTreatMentRoom] = useState<string>("");
  const [telRoom, setTelRoom] = useState<string>("081-9261709");
  const [branchRoom, setBranchRoom] = useState<string>("สำนักงานใหญ่");
  const [doctorRoom, setDoctorRoom] = useState<string>(
    "นพ.ประเสริฐ พันธุ์พรหมธาดา"
  );
  const [room, setRoom] = useState<string>("DOC3");
  const [toolRoom, setToolRoom] = useState<string>("toolRoom");
  const [theraPist, setTheraPist] = useState<string>("");
  const [notetionRoom, setNotetionRoom] = useState<string>("");
  const [timeToolFrom, setTimeToolFrom] = useState<string>("");
  const [timeToolTo, setTimeToolTo] = useState<string>("");
  const [CnTool, setCTool] = useState<string>("EK-CNT60090099");
  const [NameTool, setNameTool] = useState<string>("นายดนุภัทร สมศรี");
  const [TreatMentTool, setTreatMentTool] = useState<string>("");
  const [telTool, setTelTool] = useState<string>("081-9261709");
  const [branchTool, setBranchTool] = useState<string>("สำนักงานใหญ่");
  const [doctorTool, setDoctorTool] = useState<string>(
    "นพ.ประเสริฐ พันธุ์พรหมธาดา"
  );
  const [tool, setTool] = useState<string>("Hifu 3");
  const [roomTool, setRoomTool] = useState<string>("Hifu 3");
  const [theraPistTool, setTheraPistTool] = useState<string>("");
  const [notetionTool, setNotetionTool] = useState<string>("");
  const [valTime, setValTime] = useState<string>("");
  const [state, setState] = useState<any>({
    room: [
      {
        title: "Navasawat  14:00PM - 13:00PM",
        resourceId: "1",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "Thumrong Siripon 10:00AM - 12:00PM",
        resourceId: "2",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "นพ.ประเสริฐ พันธุ์พรหมธาดา 10:00AM - 16:00PM",
        resourceId: "3",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "Nakarin  14:00PM - 16:00PM",
        resourceId: "4",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "นายดนุภัทร สมศรี 10:00AM -  13:00PM",
        resourceId: "5",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "",
        resourceId: "6",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "",
        resourceId: "7",
        allDay: true,
        start: "2022-02-10",
        end: "2022-02-10",
      },
      {
        title: "DDDDW",
        resourceId: "1",
        allDay: false,
        start: "2022-02-10T08:30",
        end: "2022-02-10T11:00",
      },
    ],
    tool: [
      {
        title: "DDDWWWW",
        resourceId: "a",
        allDay: false,
        start: "2022-02-10T07:30",
        end: "2022-02-10T11:30",
      },
    ],
  });
  const [selectInfo, setSelectInfo] = useState<any>([]);

  const option = [
    { value: "room", name: "ห้อง" },
    { value: "tool", name: "เครื่องมือ" },
  ];

  const treatment = [
    { value: "anti1", name: "Anti-ds DNA1" },
    { value: "anti2", name: "Anti-ds DNA2" },
    { value: "anti3", name: "Anti-ds DNA3" },
    { value: "anti4", name: "Anti-ds DNA4" },
  ];

  const therapist = [
    { value: "anti1", name: "น.ส นิมล วาสุทา" },
    { value: "anti2", name: "-" },
    { value: "anti3", name: "-" },
    { value: "anti4", name: "-" },
  ];

  const doctor = [
    { value: "anti1", name: "-" },
    { value: "anti2", name: "-" },
    { value: "anti3", name: "-" },
    { value: "anti4", name: "-" },
  ];

  const times = [];
  const zeroPad = (num: number) => String(num).padStart(2, "0");

  for (let i = 7; i < 19; i++) {
    if (i <= 12) {
      times.push(`${zeroPad(i)}:00 AM`);
      times.push(`${zeroPad(i)}:30 AM`);
    } else {
      times.push(`${zeroPad(i - 12)}:00 PM`);
      times.push(`${zeroPad(i - 12)}:30 PM`);
    }
  }

  const handleDateSelect = (selectInfo: DateSelectArg) => {
    if (options === "room" && selectInfo.allDay === false) {
      setIsOpen(true);
      setValTime(selectInfo.startStr);
      setSelectInfo(selectInfo);
      setTimeRoomFrom(selectInfo.startStr.substring(11, 16));
      setTimeRoomTo(selectInfo.startStr.substring(11, 16));
    } else if (options === "tool" && selectInfo.allDay === false) {
      setIsOpen1(true);
      setValTime(selectInfo.startStr);
      setSelectInfo(selectInfo);
      setTimeToolFrom(selectInfo.startStr.substring(11, 16));
      setTimeToolTo(selectInfo.startStr.substring(11, 16));
    }
  };

  function renderEventContent(eventContent: EventContentArg) {
    return (
      <>
        {console.log(
          "eventContent.timeText.split => ",
          eventContent.timeText.split("-")[0],
          "\r\nformatDate => ",
          formatDate(eventContent.timeText.split("-")[0], {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            meridiem: false,
          })
        )}
        {eventContent.event.allDay === true ? (
          <div className="fc-sd-main">
            <b>{eventContent.event.title}</b>
          </div>
        ) : (
          <div>
            <b>Tx : {options === "room" ? CnRoom : CnTool}</b>
            <br />
            <b>Tel : {options === "room" ? telRoom : telTool}</b>
            <br />
            <b>Dr : {options === "room" ? doctorRoom : doctorTool}</b>
            <br />
            <b>Note : {"Test"}</b>
            <br />
            <b>Branch : {options === "room" ? branchRoom : branchTool}</b>
            <br />
            <b>Key : {"xxxxxxx"}</b>
            <br />
            <b>Save : {eventContent.timeText}</b>
          </div>
        )}
      </>
    );
  }

  const AddBooking = (val: any) => {};

  const OnSaveRoom = (selectInfo: any) => {
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    console.log("calendarApi Values => ", selectInfo);

    calendarApi.addEvent({
      title: "Test Room 1",
      resourceId: selectInfo.resource?.id,
      start: `${selectInfo.startStr.substring(0, 11)}${timeRoomFrom}`,
      end: `${selectInfo.endStr.substring(0, 11)}${timeRoomTo}`,
      allDay: false,
    });

    let room = state.room;
    room.push({
      title: "Test Room 1",
      resourceId: selectInfo.resource?.id,
      start: selectInfo.startStr.substring(1, 16),
      end: selectInfo.startStr.substring(1, 16),
      allDay: false,
    });
    setState({ ...state, room });
    setIsOpen(false);
  };

  const OnSaveTool = (selectInfo: any) => {
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    console.log("calendarToolApi Values => ", selectInfo);

    calendarApi.addEvent({
      title: "Test Room 1",
      resourceId: selectInfo.resource?.id,
      start: `${selectInfo.startStr.substring(0, 11)}${timeToolFrom}`,
      end: `${selectInfo.endStr.substring(0, 11)}${timeToolTo}`,
      allDay: false,
    });

    let tool = state.tool;
    tool.push({
      title: "Test Room 1",
      resourceId: selectInfo.resource?.id,
      start: `${selectInfo.startStr.substring(0, 11)}${timeToolFrom}`,
      end: `${selectInfo.endStr.substring(0, 11)}${timeToolTo}`,
      allDay: false,
    });
    setState({ ...state, tool });
    setIsOpen1(false);
  };

  const OnChangeOption = () => {
    console.log("ASD");
  };

  function onClose() {
    setIsOpen(false);
    setIsOpen1(false);
  }

  const getAPIs = () => {
    setState({ ...state, data: [], tool: [] });
  };

  useEffect(() => {
    OnChangeOption();
  }, []);

  useEffect(() => {
    console.log("isModel change....", isModel);
  }, [isModel]);

  return (
    <div>
      <div style={{ padding: "10px 40px" }}>
        <EmptyModel show={isOpen} onClose={onClose} width="30%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>Booking Add</h4>
            <div className="row justify-center mt-20">
              <Input
                className="col"
                title="เวลา"
                type="time"
                value={timeRoomFrom}
                onChange={(e) => {
                  setTimeRoomFrom(e.target.value);
                }}
              />
              <span
                style={{
                  fontSize: "14px",
                  color: "#5BAEA9",
                  width: "16px",
                  paddingTop: "5%",
                }}
              >
                ถึง
              </span>
              &nbsp;
              <Input
                className="col"
                title="เวลา"
                type="time"
                value={timeRoomTo}
                onChange={(e) => {
                  setTimeRoomTo(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="CN" value={CnRoom} />
              <Input
                className="col-6"
                title="NAME"
                value={NameRoom}
                onChange={(e) => {
                  setNameRoom(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <SelectField
                title="Treatment"
                className="col-6"
                option={treatment}
                value={TreatMentRoom}
                onChange={(e) => {
                  setTreatMentRoom(e.target.value);
                }}
              />
              <Input
                className="col-6"
                title="Tel"
                type="text"
                value={telRoom}
                onChange={(e) => {
                  setTelRoom(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="Branch" value={branchRoom} />
              <TextBox className="col-6" title="Dr." value={doctorRoom} />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="ห้อง" value={room} />
              <SelectField
                title="เครื่องมือ"
                className="col-6"
                option={doctor}
                value={toolRoom}
                onChange={(e) => {
                  setToolRoom(e.target.value);
                }}
              />
            </div>
            <div className="row justify-start mt-20">
              <SelectField
                title="THERAPIST"
                className="col-6"
                option={therapist}
                value={theraPist}
                onChange={(e) => {
                  setTheraPist(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <div style={{ color: "#aaa", fontSize: "14px" }}>หมายเหตุ</div>
              <Textarea
                rows={3}
                value={notetionRoom}
                onChange={(e) => {
                  setNotetionRoom(e.target.value);
                }}
              />
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล"
                onClick={() => {
                  OnSaveRoom(selectInfo);
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <EmptyModel show={isOpen1} onClose={onClose} width="30%">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "20px 40px",
            }}
          >
            <h4>Booking Add</h4>
            <div className="row justify-center mt-20">
              <Input
                className="col"
                title="เวลา"
                type="time"
                value={timeToolFrom}
                onChange={(e) => {
                  setTimeToolFrom(e.target.value);
                }}
              />
              <span
                style={{
                  fontSize: "14px",
                  color: "#5BAEA9",
                  width: "16px",
                  paddingTop: "5%",
                }}
              >
                ถึง
              </span>
              &nbsp;
              <Input
                className="col"
                title="เวลา"
                type="time"
                value={timeToolTo}
                onChange={(e) => {
                  setTimeToolTo(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="CN" value={CnTool} />
              <Input
                className="col-6"
                title="NAME"
                value={NameTool}
                onChange={(e) => {
                  setNameTool(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <SelectField
                title="Treatment"
                className="col-6"
                option={treatment}
                value={TreatMentTool}
                onChange={(e) => {
                  setTreatMentTool(e.target.value);
                }}
              />
              <Input
                className="col-6"
                title="Tel"
                type="text"
                value={telTool}
                onChange={(e) => {
                  setTelTool(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="Branch" value={branchTool} />
              {/* <TextBox className="col-6" title="Dr." value="นพ.ประเสริฐ พันธุ์พรหมธาดา" /> */}
              <SelectField
                title="Dr."
                className="col-6"
                option={doctor}
                value={doctorTool}
                onChange={(e) => {
                  setDoctorTool(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <TextBox className="col-6" title="ห้อง" value={roomTool} />
              <TextBox className="col-6" title="เครื่องมือ" value={tool} />
            </div>
            <div className="row justify-start mt-20">
              <SelectField
                title="THERAPIST"
                className="col-6"
                option={therapist}
                value={theraPistTool}
                onChange={(e) => {
                  setTheraPistTool(e.target.value);
                }}
              />
            </div>
            <div className="row justify-center mt-20">
              <div style={{ color: "#aaa", fontSize: "14px" }}>หมายเหตุ</div>
              <Textarea
                rows={3}
                value={notetionTool}
                onChange={(e) => {
                  setNotetionTool(e.target.value);
                }}
              />
            </div>
            <div className="justify-center mt-20">
              <MainButton
                className="mg-10"
                background="#E76464"
                title="ยกเลิก"
                onClick={() => {
                  setIsOpen1(false);
                }}
              />
              <MainButton
                className="mg-10"
                title="บันทึกข้อมูล"
                onClick={() => {
                  OnSaveTool(selectInfo);
                }}
              />
            </div>
          </div>
        </EmptyModel>
        <div className="row">
          <div
            className="col-12"
            style={{
              border: "1px solid #D3D8DD",
              height: "50px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div className="row col-10 select-padding">
              <select
                name=""
                id=""
                className="col-2 custom-select"
                onChange={(e) => {
                  setOptions(e.target.value);
                  setState({
                    ...state,
                    tool: [
                      {
                        title: "DDDWWWW",
                        resourceId: "a",
                        allDay: false,
                        start: "2022-02-10T07:30",
                        end: "2022-02-10T11:30",
                      },
                    ],
                  });
                }}
              >
                {option.map((item, index) => (
                  <option value={item.value} key={index}>
                    {item.name}
                  </option>
                ))}
              </select>
              {options === "room" ? (
                <CheckboxText className="col-2" title="OR ROOM" />
              ) : (
                <CheckboxText className="col-2" title="HELIOS II" />
              )}
              {options === "room" ? (
                <CheckboxText className="col-2" title="DOCTOR" />
              ) : (
                <CheckboxText className="col-2" title="Hifu" />
              )}
              {options === "room" ? (
                <CheckboxText className="col-2" title="TX HAIR" />
              ) : (
                <CheckboxText className="col-2" title="Me Dio Star" />
              )}
              {options === "room" ? (
                <CheckboxText className="col-2" title="HAIR TRANS" />
              ) : (
                <CheckboxText className="col-2" title="Coolsculpting" />
              )}
              {options === "room" ? (
                <CheckboxText className="col-2" title="TX ANTI" />
              ) : (
                <CheckboxText className="col-2" title="Ulthera" />
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="demo-app">
            <div className="demo-app-main">
              {/* <FullCalendar
                plugins={[resourceTimeGridPlugin, interactionPlugin]}
                initialView="resourceTimeGridDay"
                selectable={true}
                allDaySlot={options === "room" ? true : false}
                resources={
                  options === "room"
                    ? [
                        { id: "1", title: "DOC 1" },
                        { id: "2", title: "DOC 2" },
                        { id: "3", title: "DOC 3" },
                        { id: "4", title: "DOC Hair" },
                        { id: "5", title: "DOC Anti" },
                        { id: "6", title: "DOC 6" },
                        { id: "7", title: "DOC 7" },
                      ]
                    : [
                        { id: "a", title: "Hifu 1" },
                        { id: "b", title: "Hifu 2" },
                        { id: "c", title: "Hifu 3" },
                        { id: "d", title: "Hifu 4" },
                        { id: "e", title: "Hifu 5" },
                        { id: "f", title: "Hifu 6" },
                        { id: "g", title: "Hifu 7" },
                      ]
                }
                slotMinTime={"07:00"}
                slotMaxTime={"19:00"}
                select={handleDateSelect}
                eventContent={renderEventContent}
                // eventClick={handleEventClick}
                // eventsSet={handleEvents}
                events={options === "room" ? state.room : state.tool}
                schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                expandRows={true}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BookingDetail;
